import Component from 'gia/Component';
import { gsap } from "gsap";


export default class Tracker extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      blocks: [],
      percentWrapper: {},
      percent: {},
      loading: {},
      inner: {}
    };
    this.options = {
      percentage: 0
    }
  }

  mount() {
    let that = this;


    let timeline = gsap.timeline();

    timeline.fromTo(this.ref.loading, {
      opacity: 1
    }, {opacity: 0, yoyo: true, repeat: 8, duration: 0.45});

    timeline.to(this.ref.inner, {opacity: 1, duration: 0.2});
    timeline.to(this.ref.percentWrapper, {opacity: 1}, '-=0.2');

    timeline.to(this.ref.blocks, {
      opacity: 1,
      duration: 0.1,
      stagger: {
        from: "start",
        amount: 3
      }
    });

    timeline.to(this.ref.percent, {
      innerText: this.options.percentage,
      duration: 3,
      snap: {
        innerText: 1
      }
    }, '-=3')

  }


}